import { Component, Input } from '@angular/core';
import { toBoolean } from '../util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'trend',
  template: `
  <ng-content></ng-content>
  <span *ngIf="flag" class="{{flag}}">
     <i class="anticon anticon-caret-{{flag}}" nz-icon></i>
  </span>
  `,
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '[class.ad-trend]': 'true',
    '[class.grey]': '!colorful',
  },
  preserveWhitespaces: false,
})
export class TrendComponent {
  /** ä¸åä¸éæ è¯ */
  @Input() flag: 'up' | 'down';

  /** æ¯å¦å½©è²æ è®° */
  @Input()
  get colorful() {
    return this._colorful;
  }
  set colorful(value: any) {
    this._colorful = toBoolean(value);
  }
  private _colorful = true;
}
